<template lang="pug">
    MatchMedia(v-slot='{ screenSM }')
        div.notification-control
            div.notification-control__day-group(v-for="day in days")
                div.notification-control__day {{ groupedNotifications[day].dateStr }}
                div.notification-control__list(@click="linkClick")
                    div.notification-control__item(v-for="notification in groupedNotifications[day].notifications" :class="getItemClass(notification)" @click="itemClick(notification)")
                        div.notification-control__item-bg(v-if="getIsUnread(notification)")
                        creator-control.notification-control__item-info(:creator="notification.author.data" :descriptionHtml="getNotificationMessage(notification)")
                            template(v-slot:avatar-decoration)
                                div.notification-control__type-icon
                                    svg-icon(:iconId="getNotificationIconId(notification.type, screenSM)")
                        div.notification-control__time {{ notification.timeStr }}
</template>

<script>
import { MatchMedia } from 'vue-component-media-queries'
import moment from 'moment'
import NotificationsService from '../../services/notifications-service'

export default {
    name: 'notifications-control',

    components: {
        MatchMedia,
    },

    props: {
        value: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            days: [],
            readIds: [],
        }
    },

    computed: {
        notifications() {
            return this.value
        },
        groupedNotifications() {
            const groupedNotifications = {}

            const today = moment().startOf('day')
            const yesterday = today.clone().subtract(1, 'days')

            const groups = {
                [today]: () => 'Today',
                [yesterday]: () => 'Yesterday',
            }

            this.notifications.forEach(n => {
                const datetime = moment(n.created_at)
                const date = datetime.clone().startOf('day')

                const info = {
                    date,
                    dateStr: groups[date] ? groups[date](date) : date.format('D MMMM, YYYY'),
                }

                if (!groupedNotifications[date]) {
                    groupedNotifications[date] = {
                        ...info,
                        notifications: [],
                    }
                }

                groupedNotifications[date].notifications.push({
                    ...n,
                    timeStr: datetime.format('h.mm A'),
                })
            })

            return groupedNotifications
        },
    },

    watch: {
        notifications() {
            this.readIds = []
        },
        groupedNotifications: {
            handler(val) {
                this.days = Object.keys(val).sort((a, b) => val[b].date > val[a].date ? 1 : -1)
            },
            deep: true,
            immediate: true,
        },
    },

    methods: {
        getNotificationIconId(type, screenSM) {
            return `notification-icon-${type}${screenSM ? '' : '--small'}`
        },

        getNotificationMessage(notification) {
            let message = notification.message

            if (message.includes('{link}')) {
                let linkText = notification.meta.linkText
                if (linkText.includes('{linkDate}')) {
                    const linkDate = moment(notification.meta.linkDate)
                    const format = linkDate.year() == moment().year() ? 'MMM D, h:mm A' : 'MMM D YYYY, h:mm A'
                    linkText = linkText.replace('{linkDate}', linkDate.format(format))
                }
                message = message.replace('{link}', `<a href="${this.getLinkItemUrl(notification.meta.linkItemId, notification.type)}" class="notification-control__item-link">${linkText}</a>`)
            }

            return message
        },
        getLinkItemUrl(itemId, type) {
            switch (type) {
                case 'like':
                case 'interaction':
                    return `/post/${itemId}`
            }
        },

        getIsUnread(notification) {
            return !notification.is_read && !this.readIds.includes(notification.id)
        },

        itemClick(notification) {
            if (this.getIsUnread(notification)) {
                NotificationsService.read(notification.id)
                this.readIds.push(notification.id)
            }
        },

        linkClick(e) {
            if (e.target.classList.contains('notification-control__item-link')) {
                e.preventDefault()
                this.$router.push(e.target.getAttribute('href'))
            }
        },

        getItemClass(notification) {
            return {
                'notification-control__item--unread': this.getIsUnread(notification),
            }
        },
    },
}
</script>
